import { OnboardingShell } from "./OnboardingShell";

export function OnboardingServicesPage() {
  return (
    <OnboardingShell
      step={2}
      title="Danh mục dịch vụ"
      description="Thêm các dịch vụ khám + giá. Dịch vụ sẽ xuất hiện khi đặt lịch và lập hoá đơn."
      ctaTo="/settings/services"
      ctaLabel="Mở danh mục dịch vụ"
      backTo="/onboarding/clinic"
      nextTo="/onboarding/doctors"
    >
      <p className="text-sm text-muted-foreground">
        Tạo ít nhất một dịch vụ (ví dụ: Khám tổng quát) để có thể đặt lịch và thu
        phí.
      </p>
    </OnboardingShell>
  );
}
